import { render, staticRenderFns } from "./FrequencyDurationV1.vue?vue&type=template&id=1873fa8c&"
import script from "./FrequencyDurationV1.vue?vue&type=script&lang=js&"
export * from "./FrequencyDurationV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports